import React from 'react';

const FacebookIconSvg = (props) => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="24" cy="24" r="24" fill="#1877F2" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.2792 24.7233L28.8493 20.9515H25.2831V18.5038C25.2831 17.4719 25.7812 16.466 27.3786 16.466H29V13.2549C29 13.2549 27.5285 13 26.1217 13C23.1845 13 21.2648 14.8064 21.2648 18.0767V20.9515H18V24.7233H21.2648V33.8415C21.9195 33.9457 22.5905 34 23.274 34C23.9575 34 24.6285 33.9457 25.2831 33.8415V24.7233H28.2792Z"
            fill="white"
        />
    </svg>
);

export default FacebookIconSvg;
